.sprintFlyoutHeaderWrapper {
	margin: 0 0 calc(var(--jpo-common-base-spacing) * 2) 0px;
	padding: 0 0 12px 0px;
	border-bottom: 2px solid var(--ds-border, var(--adg3-color-N30));
	box-shadow: 0px 0px 0px 0px var(--adg3-color-N50A);
}

.sprintFlyoutHeaderWrapperFutureSprint {
	border-bottom: 0px;
	margin: 0px;
	padding: 0px;
}

.sprintFlyoutHeaderWarningMessage {
	border-bottom: none;
	padding-bottom: 0px;
	margin-bottom: 0px;
}

.sprintTitleWrapper {
	display: flex;
}

.sprintFlyoutHeader {
	flex: 1;
}

.warningMessageWrapper {
	margin: 8px 0px;
}

.closeFlyout {
	width: 20px;
}

.goalWrapper {
	margin-top: -2px;
}

.title {
	font-size: 20px;
	font-weight: 600;
	color: var(--ds-text, var(--adg3-color-N800));
	margin-bottom: calc(var(--jpo-common-base-spacing) * 0.5);
}

.flyout {
	min-width: 400px;
	overscroll-behavior: contain;
}

.sprintStatus {
	display: block;
	margin-bottom: calc(var(--jpo-common-base-spacing) * 0.5);
}

.subtitle {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	font-size: 14px;
	font-weight: 400;
	margin-bottom: calc(var(--jpo-common-base-spacing) * 0.5);
}

.sprintGoal {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	/*
        The following lines enable multi-line text-overflow ellipsis.
        See https://stackoverflow.com/a/13924997
        It's a bit of a hack but it works in most browsers -
        worst case, it will fall back to not having the ellipsis.
     */
	line-height: 1.43em;
	max-height: 2.86em;
	overflow: hidden;
	text-overflow: ellipsis;

	/* Suppression added when introducing stylelint to css modules */
	/* stylelint-disable value-no-vendor-prefix */
	display: -webkit-box;
	-webkit-line-clamp: 2;

	/* stylelint-enable */
}

.sprintDatesWrapper {
	display: flex;
	flex-direction: row;
}

.sprintDates {
	height: 24px;
	line-height: 24px;
}

.sprintDatesDetail {
	text-align: right;
}
.sprintStartDate {
	padding-left: 5px;
}
.sprintEndDate {
	padding-left: 3px;
}

.percentage {
	font-size: 14px;
	font-weight: 600;
	letter-spacing: -0.003em;
	color: var(--ds-text, var(--adg3-color-N800));
}

.unestimatedIssues {
	font-size: 14px;
	font-weight: normal;
	color: var(--ds-text, var(--adg3-color-N800));
}

.sprintCapacityContainer {
	margin-top: -8px;
	margin-bottom: 4px;
}

.segment {
	display: flex;
	align-items: stretch;

	& > * {
		width: 100%;
		min-width: 0;
	}

	& > .segmentIcon {
		flex: 0 0 40px;
	}

	& + .segment {
		margin-top: calc(var(--jpo-common-base-spacing) * 1.5);
	}
}

.plannedCapacityContainer {
	display: flex;
	align-items: center;
}

.plannedCapacityLabel {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	white-space: nowrap;
	margin-right: calc(var(--jpo-common-base-spacing) * 1.25);
}

.plannedCapacityInlineEdit {
	/* this is to offset the margin-top: 8px set on the FieldWrapper */
	margin-top: -8px;
}

/* the sibling of the input field wrapper is the grandfather of InlineEdit buttons */
.plannedCapacityInputWrapper + div {
	margin-top: 3px;
	/* this is a custom positioning based on the "xsmall" width of the input field */
	right: -80px;
	top: 0;
}

.plannedCapacityInlineEditReadView {
	display: flex;
	line-height: 1.42857;
	min-height: 1.42857em;
	padding: var(--jpo-common-base-spacing) 6px;
}

.plannedCapacityContainerReadOnly {
	display: flex;
	align-items: center;
	padding-bottom: var(--jpo-common-base-spacing);
	padding-top: var(--jpo-common-base-spacing);
}

.velocityRow {
	width: 100%;
	display: flex;
	justify-content: space-between;
	line-height: 2em;
}

.usedCapacity {
	font-weight: 600;
}

.editorIconFix > * {
	transform: scale(1.2);
}

.statusBreakdown > * + * {
	margin-top: var(--jpo-common-base-spacing);
}

.issuesWithoutSprint {
	display: flex;
	align-items: center;
}

.issuesWithoutSprintLabel {
	margin-right: calc(var(--jpo-common-base-spacing) * 0.5);
}

.issuesWithoutSprintInfoTooltip > div {
	display: flex;
}
